import Overlay from 'Components/Overlay';
import React from 'react';
import { Table } from "reactstrap";

const ViewUploadedFiles = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter prdetails">
        <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {props.text || 'Uploaded Files Details'} 
            </div>
            <section className="overflowAuto status-table-height bg-white pv-10 ph-10 wt-900">
              <Table striped className="upload-rfq-table col-1 fs-14 mb-30 br-5" responsive bordered>
                <thead>
                    <tr>
                        <th className='upload-td-th upload-th'></th>
                        <th className='upload-td-th upload-th'>Uploaded Files</th>
                        <th className='upload-td-th upload-th'>Remarks</th>
                        <th className='upload-td-th upload-th'>User</th>
                    </tr>
                </thead>
                <tbody>
                   {(props.data || []).map((el, index) => {
                    const bgColor = (index % 2 === 1) ? '#EFF2FD' : 'white';
                    return (<tr>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{index + 1}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}><div className='fBold curP' onClick={() => props.downloadUploadedFile(el.name)}>{el.name}</div></td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{el.remarks}</td>
                        <td className="upload-td-th" style={{ 'backgroundColor': bgColor }}>{el.userName}</td>
                    </tr>)})}
                </tbody>
            </Table>
            </section>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
            </div>
        </div>
    </Overlay>
);

export default ViewUploadedFiles;